<ng-container [formGroup]="formGroup">
    <!-- Treasury org: readonly display -->
    <input *ngIf="isTreasuryLocked"
           type="text"
           class="form-control"
           [value]="treasuryAccountName"
           disabled
           readonly />

    <!-- Non-treasury / loading: selector with built-in spinner -->
    <mat-form-field *ngIf="!isTreasuryLocked" appearance="outline" class="w-100 bg-white">
        <mat-select [formControlName]="controlName" placeholder="Select Bank Account" [compareWith]="comparator">
            <mat-option *ngIf="allowCreate" [value]="null" (click)="addBankAccount()">Add New Bank Account</mat-option>
            <ng-container *ngIf="!isLoadingAccounts">
                <ng-container *ngFor="let acct of bankAccounts">
                    <mat-option [value]="acct" [hidden]="acct.deletedAt && acct.id !== formGroup.get(controlName).value?.id">
                        {{acct.friendlyName}}
                        <ng-container *ngIf="acct.deletedAt">(deleted)</ng-container>
                    </mat-option>
                </ng-container>
            </ng-container>
        </mat-select>
        <mat-spinner *ngIf="isLoadingAccounts" [diameter]="15"></mat-spinner>
    </mat-form-field>
</ng-container>
